export default "__VITE_ASSET__Ba2n7YRF__"